/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Report_Trigger_TitleInputs */

const vi_support_report_trigger_title = /** @type {(inputs: Support_Report_Trigger_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo lỗi`)
};

/**

* @param {Support_Report_Trigger_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const support_report_trigger_title = /** @type {((inputs?: Support_Report_Trigger_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Report_Trigger_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_support_report_trigger_title(inputs)
});